// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate, Outlet } from "react-router-dom";
// import Sidebar from "../superadmin/Sidebar";
// // import { Outlet } from "react-router-dom";

// const SuperAdminSessionContainer = () => {
//   document.title = "Super Admin";
//   const superadmin = useSelector((store) => store.superadmin);

//   return (
//     <>
//       <div className="row ">
//         <Sidebar role="Super Admin" />
//         <div className="container">
// {superadmin && superadmin.authToken ? <Outlet /> : <Navigate to="/super-admin" />}
//         </div>
//       </div>
//       {/* <div className="row ">
//           <div className="col-md-3">
//             <Sidebar role="Super Admin" />
//           </div>
//           <div className="col-md-9">
//             <div className="container">
//               {superadmin ? <Outlet /> : <Navigate to="/superadmin" />}
//             </div>
//           </div>
//         </div> */}
//     </>
//   );
// };

// export default SuperAdminSessionContainer;

import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../superadmin/Sidebar";

const SuperAdminSessionContainer = () => {
  document.title = "Super Admin";

  // redux मधून superadmin
  const superadmin = useSelector((store) => store.superadmin);

  // localStorage मधून token (refresh handle करण्यासाठी)
  const token = superadmin?.authToken || localStorage.getItem("superadminToken");

  return (
    <div className="row">
      <Sidebar role="Super Admin" />
      <div className="container">
        {token ? <Outlet /> : <Navigate to="/super-admin" />}
      </div>
    </div>
  );
};

export default SuperAdminSessionContainer;
